<script>
    import Box from './Box.svelte'
    export let emoji = "😄"
    export let activity = "Activity name"
    export let likes = 0
    export let done = 0
    export let comments = 0
    export let timestamp = 0
    export let creatorId = ""
    export let activityId = ""
    export let instructions = ""
    export let link = ""

    import Icon from 'fa-svelte'
    import { faHeart as heart } from '@fortawesome/free-solid-svg-icons/faHeart'
    import { faHeart as heartOutline } from '@fortawesome/free-regular-svg-icons/faHeart'
    import { faCheck as check } from '@fortawesome/free-solid-svg-icons/faCheck'
    import { faComment as comment } from '@fortawesome/free-solid-svg-icons/faComment'
    import { faShareAlt as share } from '@fortawesome/free-solid-svg-icons/faShareAlt'
    import { faTwitter as twitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
    import { onDestroy } from 'svelte';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    import GoogleForm from 'google-form-send'

    function getUserLiked() { return JSON.parse(localStorage['activities'])[activityId]['userLiked'] }
    function getUserDone() { return JSON.parse(localStorage['activities'])[activityId]['userDone'] }
    function getNeedsRefresh() { return JSON.parse(localStorage['needsRefresh']) }
    

    $: userLiked = getUserLiked()
    $: userDone = getUserDone()
    $: needsRefresh = getNeedsRefresh()

    onDestroy ( () => {
        userLiked = getUserLiked()
        userDone = getUserDone()
        needsRefresh = getNeedsRefresh()
    })

    $: twitterLink = 'https://twitter.com/compose/tweet?url=stuckhome.fun&text=' + encodeURIComponent((userDone ? '☑️ DONE: ' : emoji + ' NEXT UP: ') + activity + '\n\nWhat are you up to? @stuckhomefun')

    function toggleLike() {
        let newPreferences = JSON.parse(localStorage['activities'])
        newPreferences[activityId].userLiked = !newPreferences[activityId].userLiked;
        localStorage['activities'] = JSON.stringify(newPreferences)

        userLiked = getUserLiked()
        likes += (userLiked ? 1 : -1)

        submitLikesDonesForm(activityId, (userLiked ? 1 : -1), 0)

        dispatch('interaction', {
            activityId: activityId,
            toggled: 'likes',
            toggleAmount: (userLiked ? 1 : -1),
        })
    }

    function toggleDone() {
        let newPreferences = JSON.parse(localStorage['activities'])
        newPreferences[activityId].userDone = !newPreferences[activityId].userDone;
        localStorage['activities'] = JSON.stringify(newPreferences)

        userDone = getUserDone()
        done += (userDone ? 1 : -1) 

        submitLikesDonesForm(activityId, 0, (userDone ? 1 : -1))

        dispatch('interaction', {
            activityId: activityId,
            toggled: 'done',
            toggleAmount: (userDone ? 1 : -1),
        })
    }

    let likesDonesForm = new GoogleForm('https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/d/e/1FAIpQLSdcaQd06cpJJILass8TRj0X3arLctmSAzZmN3bUeOKxMVrCWw/viewform')
    
    function submitLikesDonesForm(activityId, likeIncrement, doneIncrement) {

		var data = {
        'entry.1294525989': String(localStorage['userID']),
        'entry.54946649': String(activityId),
        'entry.1827336912': String(likeIncrement),
        'entry.1217493692': String(doneIncrement)
        }
        
		likesDonesForm.setAllFields(data)
		
        likesDonesForm.send(true)
        localStorage['needsRefresh'] = JSON.stringify(true)
        needsRefresh = getNeedsRefresh()

	}
</script>

<style>
    .right > button {
        min-width: 4rem;
        margin-left: 1rem;
    }

    icon {
        vertical-align: middle;
    }

</style>

<Box>
    <h3>{emoji} {activity}</h3>
    <p>
        {instructions}
        {#if (link != '')}
         <a target="_blank" href={link}>Start here</a>.
        {/if}
    </p>
    <span class='right' slot='right-accessory'>
        <button on:click={toggleLike} class={userLiked ? 'red' : 'gray'}>
            <icon>
                <Icon icon={heart}></Icon>
            </icon>
            <span>&nbsp;{likes}</span>
        </button>
        <button on:click={toggleDone} class={userDone ? '' : 'gray'}>
            <icon>
                <Icon icon={check}></Icon>
            </icon>
            <span>&nbsp;{done}</span>
        </button>
        <!-- <button class='gray'>
            <icon>
                <Icon icon={comment}></Icon>
            </icon>
            <span>&nbsp;{comments}</span>
        </button> -->
    </span>
    <span slot='left-accessory'>
        <a href={twitterLink}>
            <button class='gray'>
                <icon>
                    <Icon icon={twitter}></Icon>
                </icon>
            </button>
        </a>
    </span>
</Box>